import React, { useState, useEffect } from 'react';
import DataTable from 'react-data-table-component';
import { custTableStyles } from '../../../style/color';

import { FaUserFriends, FaChartLine, FaFilter, FaDownload } from 'react-icons/fa';
import { MdAgriculture, MdRefresh } from 'react-icons/md';
import { GiField, GiFruitBowl } from 'react-icons/gi';
import { BiSearch } from 'react-icons/bi';
import { mainurl, imgurl } from '../../../Mainurl';
import axios from 'axios';

import { Row, Col, Card, CardHeader, CardBody, FormGroup, Input, Label, Button, Spinner } from 'reactstrap';

const Operation = () => {
    const [loading, setLoading] = useState(false);
    const [stats, setStats] = useState('');
    const [tableData, setTableData] = useState('');
    const [cropTypeName, setCropTypeName] = useState('');
    const [cropTypeOpt, setCropTypeOpt] = useState('');
    const [cropType, setCropType] = useState('');
    const [cropOpt, setCropOpt] = useState('');
    const [crop, setCrop] = useState('');
    const [searchTerm, setSearchTerm] = useState('');

    useEffect(() => {
        get_db_stats();

        let postData = [{"org_id": sessionStorage.getItem('org_id'), "user_id": sessionStorage.getItem('user_id'), "lang_id": 1}];
        axios({
            method: 'post',
            url: mainurl + 'Master/box_crop_type_list',
            data: postData,
            headers: { 'Content-Type': 'application/JSON', }
        })
            .then(function (response) {
                let list = response.data.map((row, index) => {
                    return(
                        <option key={index} value={row.crop_type_id}> {row.crop_type_name}</option>
                    )
                });

                setCropTypeOpt(list);
            })
            .catch(error => {
                setLoading(false);
                // Error handling
            });
    }, [])

    const get_db_stats = () => {
        let postData = [{"org_id": sessionStorage.getItem('org_id')}];
        axios({
            method: 'post',
            url: mainurl + 'Master/web_org_stats',
            data: postData,
            headers: { 'Content-Type': 'application/JSON', }
        })
            .then(function (response) {
                setStats(response.data[0]);
            })
            .catch(error => {
                // Error handling
            });
    }

    const get_crop_list = (e) => {
        setCropOpt('');
        setCrop("0");
        setCropType(e.target.value);
        setTableData('');
        setCropTypeName(e.target.selectedOptions[0].text)
        let postData = [{"org_id": sessionStorage.getItem('org_id'), "user_id": sessionStorage.getItem('user_id'), "crop_type_id": e.target.value, "lang_id": 1}];

        axios({
            method: 'post',
            url: mainurl + 'Master/box_crop_master_list',
            data: postData,
            headers: { 'Content-Type': 'application/JSON', }
        })
            .then(function (response) {
                let list = response.data.map((row, index) => {
                    return(
                        <option key={index} value={row.crop_code}> {row.crop_name}</option>
                    )
                });

                setCropOpt(list);
            })
            .catch(error => {
                setLoading(false);
                // Error handling
            });
    }

    const crop_variety_list = (e) => {
        setTableData('');
        setLoading(true);
        setCrop(e.target.value);
        let postData = [{"org_id": sessionStorage.getItem('org_id'), "user_id": sessionStorage.getItem('user_id'), "crop_code": e.target.value, "lang_id": 1}]
        axios({
            method: 'post',
            url: mainurl + 'Master/box_crop_variety_list_active',
            data: postData,
            headers: { 'Content-Type': 'application/JSON', }
        })
            .then(function (response) {
                let list = response.data.map((row, index) => {
                    let far; let status; let validity;
                    if(row.active != null){
                        far = row.active[0].max_farmer; 
                        status = <span className="badge bg-success">Active</span>;
                        validity = row.active[0].validity_date;
                    }else{
                        far = 0; 
                        status = <span className="badge bg-secondary">Not Active</span>;
                        validity = 'N/A';
                    }
                    return(
                        {
                            sl: index + 1,
                            name: row.crop_variety_name,
                            farmers: far,
                            validity: validity,
                            status: status,
                        }
                    )
                });

                setTableData(list);
                setLoading(false);
            })
            .catch(error => {
                setLoading(false);
                // Error handling
            });
    }

    const handleRefresh = () => {
        get_db_stats();
    };

    const filteredData = tableData ? tableData.filter(item => 
        item.name.toLowerCase().includes(searchTerm.toLowerCase())
    ) : [];

    const customTableStyles = {
        headRow: {
            style: {
                backgroundColor: '#f8f9fa',
                borderBottom: '2px solid #dee2e6',
                minHeight: '52px',
            },
        },
        headCells: {
            style: {
                fontSize: '14px',
                fontWeight: '600',
                color: '#495057',
                paddingLeft: '16px',
                paddingRight: '16px',
            },
        },
        rows: {
            style: {
                minHeight: '48px',
                '&:hover': {
                    backgroundColor: '#f8f9fa',
                    cursor: 'pointer',
                },
            },
        },
        cells: {
            style: {
                paddingLeft: '16px',
                paddingRight: '16px',
                fontSize: '14px',
            },
        },
    };

    const StatCard = ({ title, value, icon: Icon, color, bgColor, trend }) => (
        <Card className="stat-card h-100 shadow-sm border-0">
            <CardBody className="p-4">
                <div className={"d-flex align-items-center justify-content-between " + color} >
                    <div className="flex-grow-1">
                        <h6 className="stat-title text-muted mb-2 fw-medium">{title}</h6>
                        <h3 className="stat-value mb-1 fw-bold">{value || '0'}</h3>
                        {trend && <small className="text-success">{trend}</small>}
                    </div>
                    <div className="stat-icon-wrapper">
                        <div 
                            className="stat-icon d-flex align-items-center justify-content-center"
                            style={{ backgroundColor: bgColor, color }}
                        >
                            <Icon size={28} />
                        </div>
                    </div>
                </div>
            </CardBody>
        </Card>
    );

    return(
        <>
            <style jsx>{`
                .stat-card {
                    transition: transform 0.2s ease, box-shadow 0.2s ease;
                    border-radius: 10px !important;
                }

                .stat-card:hover {
                    transform: translateY(-2px);
                    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15) !important;
                }

                .stat-icon {
                    width: 60px;
                    height: 60px;
                    border-radius: 12px;
                    font-size: 1.5rem;
                }

                .stat-title {
                    font-size: 0.85rem;
                    letter-spacing: 0.5px;
                }

                .stat-value {
                    font-size: 2rem;
                    line-height: 1.2;
                }

                .filter-card {
                    background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
                    border: 1px solid #e9ecef;
                    border-radius: 12px;
                    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
                }

                .data-card {
                    border-radius: 12px;
                    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
                    overflow: hidden;
                }

                .search-wrapper {
                    position: relative;
                }

                .search-icon {
                    position: absolute;
                    left: 12px;
                    top: 50%;
                    transform: translateY(-50%);
                    color: #6c757d;
                    z-index: 1;
                }

                .search-input {
                    padding-left: 40px;
                    border-radius: 8px;
                    border: 1px solid #ced4da;
                    font-size: 14px;
                }

                .action-buttons {
                    gap: 8px;
                }

                .btn-action {
                    border-radius: 8px;
                    font-size: 14px;
                    font-weight: 500;
                    padding: 8px 16px;
                    display: flex;
                    align-items: center;
                    gap: 8px;
                    transition: all 0.2s ease;
                }

                .btn-primary:hover {
                    transform: translateY(-1px);
                }

                .select-modern {
                    border-radius: 8px;
                    border: 1px solid #ced4da;
                    font-size: 14px;
                    transition: border-color 0.2s ease, box-shadow 0.2s ease;
                }

                @media (max-width: 768px) {
                    .stat-value {
                        font-size: 1.5rem;
                    }
                    
                    .stat-icon {
                        width: 50px;
                        height: 50px;
                    }

                    .action-buttons {
                        flex-direction: column;
                    }
                }
            `}</style>

            {/* Statistics Cards */}
            <Row className="g-4 mb-4">
                <Col lg={3} md={6}>
                    <StatCard
                        title="Total Farmers"
                        value={stats?.farmer_count}
                        icon={FaUserFriends}
                        bgColor="#07653815"
                        trend="Active members"
                        color= "text-primary"
                    />
                </Col>
                <Col lg={3} md={6}>
                    <StatCard
                        title="Total Cultivation"
                        value={stats?.cultivation_count}
                        icon={MdAgriculture}
                        bgColor="#2E8B5715"
                        trend="Ongoing projects"
                        color= "text-success"
                    />
                </Col>
                <Col lg={3} md={6}>
                    <StatCard
                        title="Cultivation Area"
                        value="402 Acres"
                        icon={GiField}
                        bgColor="#DAA52015"
                        trend="Total coverage"
                        color= "text-warning"
                    />
                </Col>
                <Col lg={3} md={6}>
                    <StatCard
                        title="Total Crops"
                        value={stats?.active_crop}
                        icon={GiFruitBowl}
                        bgColor="#CD5C5C15"
                        trend="Active varieties"
                        color= "text-danger"
                    />
                </Col>
            </Row>

            {/* Filters Section */}
            <Row className="mb-4">
                <Col xs={12}>
                    <Card className="filter-card border-0">
                        <CardBody className="p-4">
                            <div className="d-flex align-items-center justify-content-between mb-3">
                                <h5 className="mb-0 fw-bold d-flex align-items-center gap-2">
                                    <FaFilter className="text-primary" />
                                    Crop Selection & Filters
                                </h5>
                                <Button 
                                    color="outline-primary" 
                                    size="sm" 
                                    onClick={handleRefresh}
                                >
                                    <MdRefresh /> Refresh
                                </Button>
                            </div>
                            
                            <Row className="g-3">
                                <Col lg={3} md={6}>
                                    <Label className="form-label fw-medium">Crop Type</Label>
                                    <Input 
                                        type="select" 
                                        value={cropType} 
                                        onChange={get_crop_list}
                                        className="select-modern"
                                    >
                                        <option value="0">-- Select Crop Type --</option>
                                        {cropTypeOpt}
                                    </Input>
                                </Col>
                                <Col lg={3} md={6}>
                                    <Label className="form-label fw-medium">Crop</Label>
                                    <Input 
                                        type="select" 
                                        value={crop} 
                                        onChange={crop_variety_list}
                                        className="select-modern"
                                        disabled={!cropOpt}
                                    >
                                        <option value="0">-- Select Crop --</option>
                                        {cropOpt}
                                    </Input>
                                </Col>
                                <Col lg={4} md={8}>
                                    <Label className="form-label fw-medium">Search Varieties</Label>
                                    <div className="search-wrapper">
                                        <BiSearch className="search-icon" size={16} />
                                        <Input
                                            type="text"
                                            placeholder="Search crop varieties..."
                                            value={searchTerm}
                                            onChange={(e) => setSearchTerm(e.target.value)}
                                            className="search-input"
                                        />
                                    </div>
                                </Col>
                                <Col lg={2} md={4} className="d-flex align-items-end">
                                    <div className="action-buttons d-flex w-100">
                                        <Button 
                                            color="primary" 
                                            size="sm" 
                                            block
                                            disabled={!tableData || filteredData.length === 0}
                                        >
                                            <FaDownload /> Export
                                        </Button>
                                    </div>
                                </Col>
                            </Row>
                        </CardBody>
                    </Card>
                </Col>
            </Row>

            {/* Data Table Section */}
            <Row>
                <Col xs={12}>
                    <Card className="data-card border-0">
                        <CardHeader className="bg-white border-bottom px-4 py-3">
                            <div className="d-flex align-items-center justify-content-between">
                                <h5 className="mb-0 fw-bold d-flex align-items-center gap-2">
                                    <FaChartLine className="text-primary" />
                                    {cropTypeName || 'Crop Varieties'} 
                                    {filteredData.length > 0 && (
                                        <span className="badge bg-primary ms-2">{filteredData.length}</span>
                                    )}
                                </h5>
                                {loading && (
                                    <div className="d-flex align-items-center gap-2 text-muted">
                                        <Spinner size="sm" />
                                        <small>Loading data...</small>
                                    </div>
                                )}
                            </div>
                        </CardHeader>
                        <CardBody className="p-0">
                            <DataTable
                                customStyles={customTableStyles}
                                columns={[
                                    {
                                        name: 'S.No',
                                        selector: row => row.sl,
                                        sortable: true,
                                        width: "80px",
                                        center: true,
                                    },
                                    {
                                        name: 'Variety Name',
                                        selector: row => row.name,
                                        sortable: true,
                                        grow: 2,
                                        cell: row => (
                                            <div className="fw-medium">{row.name}</div>
                                        )
                                    },
                                    {
                                        name: 'Max Farmers',
                                        selector: row => row.farmers,
                                        sortable: true,
                                        center: true,
                                        cell: row => (
                                            <span className="fw-bold text-primary">{row.farmers}</span>
                                        )
                                    },
                                    {
                                        name: 'Validity Date',
                                        selector: row => row.validity,
                                        sortable: true,
                                        center: true,
                                    },
                                    {
                                        name: 'Status',
                                        selector: row => row.status,
                                        sortable: true,
                                        center: true,
                                    },
                                ]}
                                data={filteredData}
                                highlightOnHover
                                pointerOnHover
                                progressPending={loading}
                                progressComponent={
                                    <div className="d-flex flex-column align-items-center justify-content-center p-4">
                                        <Spinner color="primary" />
                                        <p className="mt-2 text-muted">Loading crop varieties...</p>
                                    </div>
                                }
                                noDataComponent={
                                    <div className="d-flex flex-column align-items-center justify-content-center p-4">
                                        <GiFruitBowl size={48} className="text-muted mb-3" />
                                        <h6 className="text-muted">No crop varieties found</h6>
                                        <p className="text-muted small mb-0">
                                            {cropType ? 'Try selecting a different crop or crop type' : 'Please select a crop type and crop to view varieties'}
                                        </p>
                                    </div>
                                }
                                pagination
                                paginationPerPage={10}
                                paginationRowsPerPageOptions={[5, 10, 15, 20]}
                            />
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        </>
    )
}

export default Operation;